import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../../environments/environment';

export function internalGroupGuard(): CanActivateFn {
  return () => {
    const msalService = inject(MsalService);
    const router = inject(Router);

    const account = msalService.instance.getActiveAccount();
    const groups: string[] = (account?.idTokenClaims as any)?.groups ?? [];
    const requiredGroup = environment.internalGroupId;

    if (requiredGroup && groups.includes(requiredGroup)) {
      return true;
    }

    return router.createUrlTree(['/error/error-403']);
  };
}
